import { object, string, InferType, mixed, ref, date } from 'yup';


export enum ChoixResiliation {
  Maintenant = "MAINTENANT",
  ProchaineEcheance = "PROCHAINEECHANCE"
}

export const choixSchema = object().shape({
  choixResiliation: mixed<ChoixResiliation>()
    .oneOf(
      [ChoixResiliation.ProchaineEcheance, ChoixResiliation.Maintenant]
    )
    .required("Merci de sélectionner l'un des choix"),
});

export const informationsSchema = object({
  lastname: string().required("Merci de compléter cette information"),
  firstname: string().required("Merci de compléter cette information"),
  nRue: string(),
  adresse: string().required("Merci de compléter cette information"),
  codePostal: string().matches(
    /^[0-9\b]+$/, {
    message: "Format invalide",
    excludeEmptyString: true
  }).length(5, "Format invalide")
    .required("Merci de compléter cette information"),
  ville: string().matches(
    /^[a-zA-Z\s-]+$/, {
    message: "Format invalide",
    excludeEmptyString: true
  }).required("Merci de compléter cette information"),

  dateNaissance: string()
    .required("Merci de compléter cette information")
    .test(
      "DOB",
      "L’assuré doit être âgé de 18 ans ou plus",
      value => {
        if (typeof value === 'string') {
          const birthDate = new Date(value);
          const currentDate = new Date();
          const ageDiff = currentDate.getFullYear() - birthDate.getFullYear();

          if (ageDiff > 18) {
            return true;
          } else if (ageDiff === 18) {
            const currentMonth = currentDate.getMonth();
            const birthMonth = birthDate.getMonth();
            if (currentMonth > birthMonth) {
              return true;
            } else if (currentMonth === birthMonth) {
              if (currentDate.getDate() >= birthDate.getDate()) {
                return true;
              }
            }
          }
        }

        return false;
      }
    )
  ,

  numTel: string().matches(
    /^[0-9\b]+$/, {
    message: "Format invalide",
    excludeEmptyString: true
  }).length(10, "Format invalide").required("Merci de compléter cette information"),
  email: string().email("Format invalide").required('Merci de compléter cette information'),
  emailComfirmation: string()
    .oneOf([ref('email')], 'Les deux E-mail ne sont pas identiques')
    .email('Format invalide')
    .required('Merci de compléter cette information'),


});

export const contratSchema = object({
  produit: string(),
  nomContrat: string(),
  nomGarantie: string(),
  numAdhesion: string().required("Merci de compléter cette information"),
});




export const motifMaintenantSchema = object().shape({
  motif: string().required('Merci de sélectionner l’un des choix'),
  date: date().transform(
    value => {
      return (value)
    }
  ).when('motif', {
    is: (value: any) =>
      value === 'Je ne détiens plus le bien assuré' ||
      value === 'Ma situation personnelle a changé' ||
      value === '',
    then: date()
      .required('Merci de renseigner cette information')
      .transform((value) => value ?? new Date(value))
      .max(new Date(), 'La date doit être antérieure à aujourd\'hui'),
  }).nullable(),
  description: string().when('motif', {
    is: (value: any) => value === 'Autre' || value === 'Ma situation personnelle a changé' || value === '',
    then: string().required('Merci de renseigner cette information').min(20, 'Veuillez saisir au minimum 20 caractères').max(498, 'Nombre maximum de caractères autorisés atteint'),
  }),
});


export const recapSchema = object({

  recaptcha: string().required("La validation du captcha est obligatoire !")

});

export type Informations = InferType<typeof informationsSchema>;
export type Contrat = InferType<typeof contratSchema>;
export type ChoixResil = InferType<typeof choixSchema>;
export type MotifMaintenantSchema = InferType<typeof motifMaintenantSchema>;
export type Recap = InferType<typeof recapSchema>;
export type Resiliation = {
  informations: Informations,
  contrat: Contrat,
  choixResil: ChoixResil,
  motifMaintenant: MotifMaintenantSchema,
  recap: Recap,
};

export type motifMaintenantSchema = {
  motif: 'je ne détiens plus le bien assuré' | 'ma situation personnelle a changé' | 'autre';
  date: Date | null;
  description: string;
};
